module.exports = __webpack_public_path__ + "static/media/undraw_Waiting__for_you_ldha.49107080.svg";